/**
 * Slugs de las páginas de "expertise" (servicios). El texto de cada una
 * (eyebrow/title/lead/definition/capabilities/process/faq) vive en i18n
 * bajo `expertise.<slug>`.
 */
export const EXPERTISE_SLUGS = [
    "inteligencia-artificial",
    "software-y-aplicaciones",
    "ciberseguridad",
];

/** Slug de la página especial de aviación (también vive bajo `expertise.<slug>` en i18n). */
export const AVIATION_SLUG = "aviation";

/**
 * Fuentes marco de la página de aviación: nombres de instituciones y URLs
 * oficiales, se mantienen sin traducir (nombres propios en inglés).
 */
export const AVIATION_SOURCES = [
    ["ICAO — Safety Management", "https://www.icao.int/safety-management"],
    ["EASA — Artificial Intelligence", "https://www.easa.europa.eu/en/domains/research-innovation/ai"],
    ["FAA — Roadmap for AI Safety Assurance", "https://www.faa.gov/aircraft/air_cert/step/roadmap_for_AI_safety_assurance"],
];
